import {useTranslations} from "next-intl";

export default function ComponentContactSectionText() {
    const t = useTranslations('SectionContactUs');
    return t('aboutUsDefaultText')
}